import { SET_CART_DATA } from "../../redux/actions/action.types";

export default function setCartData(stateHandler: any, data: any) {
  stateHandler({
    type: SET_CART_DATA,
    payload: data,
  });
}
